(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["phenotyp-login"]) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-ph-account-redirect]');
    const destination = section?.dataset.phAccountRedirect;
    if (destination) window.location.replace(destination);
  })();

  } catch(e) { console.error(e); }
})();
})();
